export const dateInputRegex = /[\d/]/g
export const dateCharacters = '0123456789/'

export const LINKS = [
  {
    to: '/my-activities',
    stringKey: 'my_activities',
    key: 'activities'
  },
  {
    to: '/visits',
    stringKey: 'visits',
    key: 'visits',
    title: 'Visits'
  },
  {
    to: '/profile',
    stringKey: 'profile',
    key: 'profile'
  },
  {
    to: '/select-ptp',
    stringKey: 'select_ptp',
    key: 'select_ptp',
    title: 'Select Participant'
  }
]

export const SUBROUTES = {
  announcements: 'announcements',
  activities: 'activities',
  profile: 'profile',
  password: 'password',
  visits: 'visits',
  select_ptp: 'select_ptp'
}

export const QUESTION_TYPES = {
  acq7: 'acq7_q7',
  audio: 'audio_recording',
  date: 'date',
  datetime: 'datetime',
  decimal: 'decimal',
  horizontalSelectOne: 'horizontal_select_one',
  imageCapture: 'image_capture',
  integer: 'integer',
  introduction: 'introduction',
  likert: 'likert',
  multipleField: 'multiple_field',
  numericRatingScale: 'numeric_rating_scale',
  matrix: 'matrix',
  prompt: 'prompt',
  resumeReview: 'resume-review',
  review: 'review',
  scribble: 'scribble',
  selectMultiple: 'select_multiple',
  selectOne: 'select_one',
  submission: 'submission',
  text: 'text',
  time: 'time',
  timer: 'timer',
  timedMatchingGrid: 'timed_matching_grid',
  vaScale: 'va_scale',
  vaScale2021: 'va_scale_2021',
  vasHorizontal: 'vas_horizontal'
}

export const BROWSER_TYPE_MAP = {
  chrome: 'chrome',
  safari: 'safari',
  firefox: 'firefox',
  edge: 'edge',
  ie: 'IE',
  opera: 'opera'
}

export const DEFAULT_LANGUAGE_KEY = 'en-US'

export const ISO8601_DATETIME_FORMATS = {
  date: 'YYYY-MM-DD',
  datetime: 'YYYY-MM-DD HH:mm',
  time: 'HH:mm'
}

export const VISUAL_ACCESSIBILITY_MODES_MAP = {
  black: 'black'
}

export const LOCAL_STORAGE_KEYS = {
  localization: 'localization',
  strings: 'strings',
  user: 'user',
  selectedPtp: 'selected_ptp'
}

export const SESSION_STORAGE_KEYS = {
  caregiverParticipants: 'caregiver_participants'
}

// Placeholder tokens
export const SUBJECT_ID_PLACEHOLDER = '[SubjectId]'

// Fallback UI strings used when localization service does not return values
export const FALLBACK_STRINGS = {
  select_ptp: 'Select Participant',
  selected_ptp_prefix: 'Selected Participant',
  not_signed: 'Not signed',
  signed_on: 'Signed on',
  no_consents_to_display: 'No Consents to display',
  consent_skip_heading: 'Skip consent for now?',
  consent_skip_content: 'You will be able to access this consent again later.',
  consent_decline_heading: 'Choose not to consent?',
  consent_decline_content_blocking: 'You must consent to participate in the study.',
  consent_decline_content_non_blocking: 'Your study team will be notified and may contact you shortly',
  consent_decline_confirm_button: 'I do not consent',
  consent_read_heading: 'Finished reviewing the consent form?',
  consent_read_content: 'Your study team may contact you shortly regarding next steps.',
  consent_read_confirm_button: 'Confirm',
  return_button: 'Return',
  skip: 'Skip',
  consent_completed_heading: 'Great job!',
  consent_completed_message_prefix: "Great job! You've successfully completed ",
  consent_completed_message_suffix: ' consent',
  consent_completed_done_button: 'Done',
  consent_awaiting_signatures_heading: 'Collecting additional signatures',
  consent_awaiting_signatures_message: "We'll send you a notification to come back.",
  got_it: 'Got it',
  // GOLD-12178: Backup when Applanga/strings omit these new TMG keys.
  timed_matching_grid_digit_guidance:
    'Enter the matching number (1–9). Cursor advances automatically. Next unlocks when all items are answered or the timer ends.',
  timed_matching_grid_checkmark_guidance:
    // eslint-disable-next-line max-len
    "Check the box only if the number is incorrect, leave it unchecked if it's correct. The user can manually navigate to the next item using the arrow keys."
}

// Caregiver selection overlay default copy
export const CAREGIVER_OVERLAY_TITLE = 'Participant Selection Required'
export const CAREGIVER_OVERLAY_MESSAGE =
  'Please select a participant to access this tab. You can try again once a selection has been made.'

// Caregiver assignment overlay (no participants)
export const CAREGIVER_ASSIGNMENT_OVERLAY_TITLE =
  'Participant Assignment Required'

export const STATES_TO_RESET_ARR = [
  'webSurveys',
  'instruments',
  'announcements',
  'files',
  'caregiver',
  'consent'
]

export const RTL_LOCALES = new Set([
  'ar',
  'ar_il',
  'ar_eg',
  'ar-il',
  'ar-eg',
  'he',
  'he_il',
  'he-il',
  'ur',
  'ur-in',
  'ur_in'
])

export const INSTRUMENT_EVENTS_MAP = {
  delivered: 'instrument_delivered',
  visible: 'instrument_visible',
  seen: 'instrument_seen',
  read: 'instrument_read',
  completed: 'instrument_completed',
  cancelled: 'instrument_cancelled',
  parsingFailed: 'instrument_parsing_failed',
  downloadFailed: 'instrument_download_failed',
  submitFailed: 'instrument_submit_failed'
}

export const ANNOUNCEMENT_EVENTS_MAP = {
  delivered: 'announcement_delivered',
  visible: 'announcement_visible',
  seen: 'announcement_seen',
  read: 'announcement_read'
}

export const EVENT_KEY_MAP = {
  instrumentsDepQId: 'instruments_deployment_queue_id',
  depQId: 'deployment_queue_id',
  announcementId: 'announcement_id',
  instrumentId: 'instrument_id',
  instrumentInstanceId: 'instrument_instance_id',
  instanceId: 'instance_id'
}

export const INSTRUMENT_VISIBILITY_MAP = {
  allDay: 'all_day',
  specificTime: 'specific_time',
  custom: 'custom',
}

export const DEFAULT_INSTANCE_VISIBLE_DAYS = 0

export const INSTRUMENT_RECURRING_SCHEME_MAP = {
  persistent: 'persistent',
  nDays: 'n-days'
}

export const INSTRUMENT_DISPLAY_LOCATION_OPTIONS = {
  carousel: 'CAROUSEL',
  calendar: 'CALENDAR'
}

export const WEB_SUPPORTED_INSTRUMENT_TYPES = ['SURVEY', 'ARTICLE', 'EDIARY']

export const UNTITLED_INSTRUMENT = 'Untitled Instrument'

export const MAX_TIMEOUT_SECONDS = 24 * 24 * 60 * 60 // 24 days in seconds
export const DEFAULT_TIMEOUT_SECONDS = 60
export const MS_IN_SECOND = 1000
export const SECONDS_IN_MINUTE = 60

export const EXPIRATION_TAG_MAX_DAYS = 3

export const ACQ7_INPUT_LABELS = {
  fevPreBronchodilator: 'FEV_Pre_Bronchodilator',
  fevPredicted1: 'FEV_Predicted_1',
  fevPredicted2: 'FEV_Predicted_2',
  fevScore: 'FEV_Score'
}

// Consent-related constants
export const USER_TYPES = {
  participant: 'participant',
  caregiver: 'caregiver'
}

export const CONSENT_SECTION_TYPES = {
  prompt: 'prompt',
  signature: 'signature',
  pdf: 'pdf'
}

// Signature modes
export const CONSENT_SIGNATURE_MODES = {
  draw: 'draw',
  photoUpload: 'photo_upload',
  text: 'text',
  image: 'image',
  pdf: 'pdf'
}

export const CONSENT_PARTICIPANT_STATUSES = {
  awaitingAdmin: 'awaiting_admin',
  awaitingWitness: 'awaiting_witness',
  awaitingClinro: 'awaiting_clinro'
}

// Survey/Consent response state constants
export const RESPONSE_STATES = {
  skipped: 'SKIPPED',
  answered: 'ANSWERED'
}

// Consent submission-level state constants
export const SUBMISSION_STATES = {
  valid: 'VALID'
}

// Caregiver consent text constants
export const CAREGIVER_TEXT = {
  heading: 'Caregiver:'
}

// Participant consent text constants
export const PARTICIPANT_TEXT = {
  heading: 'Participant Signature'
}

// Consent-specific UI text (non-localized per requirement)
export const CONSENT_TEXT = {
  skip: 'Skip',
  skipSignature: 'Skip signature',
  skipThisSignatureHeading: 'Skip this signature?',
  skipThisSignatureText:
    'This signature is optional and will not block your participation in the study.',
  return: 'Return'
}

// Consent UI copy used in Signature flow
export const CONSENT_UI_TEXT = {
  printToSign: 'Print to sign',
  uploadDropText: 'Drag and drop the full signed consent here',
  orText: 'or',
  uploadFile: 'Upload file',
  removeUploadedFileAria: 'Remove uploaded file',
  removeConfirmHeading: 'Are you sure',
  removeConfirmText: 'you want to remove this file?',
  removeConfirmRemove: 'Remove',
  removeConfirmCancel: 'Cancel'
}

// File types allowed for consent photo upload
export const CONSENT_UPLOAD_ACCEPT = '.png,.jpg,.jpeg,.pdf'
export const MEDIA_ELEMENTS = ['video', 'audio']

// Alt text used by consent signature UI images
export const CONSENT_ALT_TEXT = {
  draw: 'Draw',
  camera: 'Camera',
  print: 'Print',
  upload: 'Upload',
  fileIcon: 'FileUploaded'
}
export const PENDING_CONSENTS = 'Pending Consent(s)'
export const COMPLETED_CONSENTS = 'Signed Consent(s)'
export const EXPANDED = 'expanded'
export const COLLAPSED = 'collapsed'

export const BLOCKING_CONSENT_MODAL_TEXT = {
  consentRequired: 'Consent Required',
  pleaseCompleteConsent:
    'Please complete the required consent to access this section'
}
export const LABEL = 'Label'
export const HPI_HARDWARE_ID_HEADER_NAME = 'hpi-hardware-id'
